module.exports = __webpack_public_path__ + "fonts/d90fa98.otf";